import { render, staticRenderFns } from "./CourseActionGroups.vue?vue&type=template&id=0b7eb0ba&scoped=true&"
import script from "./CourseActionGroups.vue?vue&type=script&lang=js&"
export * from "./CourseActionGroups.vue?vue&type=script&lang=js&"
import style0 from "./CourseActionGroups.vue?vue&type=style&index=0&id=0b7eb0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7eb0ba",
  null
  
)

export default component.exports